import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWikiquoteComponent } from './simple-icons-wikiquote.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWikiquoteComponent ],
    exports:      [ SimpleIconsWikiquoteComponent ],
    bootstrap:    []
})
export class SimpleIconsWikiquoteModule {}
